import { Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CardContainer from "../../../../commons/cards/CardContainer";
import DatosDelEstablecimientoCard from "../../../../commons/establecimiento/DatosDelEstablecimientoCard";
import { StyledResolucion } from "../../../../styled/Prevencion";

const EstablecimientoCard = ({ searchedRes, nextForm, handleCancelResolucion }) => {
  const { state } = useLocation();
  const datosEstablecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento
  );
  const formulariosPresentados = useSelector(
    (state) => state.resolucion.formulariosPresentados
  );
  const validacionCargaResolucion = useSelector(
    (state) => state.resolucion.validarDisponibilidadCargaRes
  );
  const searchedEstablecimiento = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  const loadingFormularioAnterior = useSelector(
    (state) => state.resolucion.formularioAnterior.loading
  )

  const noHayDatosEstablecimiento = !datosEstablecimiento?.data?.nombre;
  const noBuscoEstablecimiento = !searchedEstablecimiento;
  const hayErrorValidacionResolucion = validacionCargaResolucion?.error;
  const noPuedeContinuarCargaRes = state?.idDependenciaEmpleador ?
    loadingFormularioAnterior || noHayDatosEstablecimiento || noBuscoEstablecimiento
    :
    noBuscoEstablecimiento || noHayDatosEstablecimiento || loadingFormularioAnterior || hayErrorValidacionResolucion

  const handleSubmit = () => {
    nextForm("Cabecera");
  };

  return (
    <>
      <StyledResolucion.CardsContainer container spacing={2}>
        {searchedRes ? (
          <>
            <StyledResolucion.Card item xs={12}>
              <CardContainer
                title="Datos del Establecimiento"
                loading={datosEstablecimiento.loading}
                componente={
                  <DatosDelEstablecimientoCard
                    data={datosEstablecimiento.data}
                  />
                }
                getData={() => { }}
              />
            </StyledResolucion.Card>
          </>
        ) : (
          <StyledResolucion.LoadingContainer item xs={12} style={{ height: 350 }}>
            <Typography
              style={{
                color: "grey",
                textAlign: "center",
              }}
            >
              Busque un establecimiento.
            </Typography>
          </StyledResolucion.LoadingContainer>
        )}
      </StyledResolucion.CardsContainer>
      <StyledResolucion.ButtonContainer style={{ padding: 20, width: "auto" }}>
        {
          state?.idDependenciaEmpleador ?
            <StyledResolucion.CancelButton
              variant="contained"
              onClick={handleCancelResolucion}
            >
              CANCELAR FORMULARIO
            </StyledResolucion.CancelButton>
            : null
        }
        <Button
          color="primary"
          variant="contained"
          onClick={handleSubmit}
          disabled={noPuedeContinuarCargaRes}
        >
          SIGUIENTE
        </Button>
      </StyledResolucion.ButtonContainer>
    </>
  );
};

export default EstablecimientoCard;
